import { useUserMeStore } from '../../../../../store';
import { CohortType } from '@prisma/client';
import { observer } from 'mobx-react';
import { RepeatedQuestionnaireDialog } from './RepeatedQuestionnaireDialog';
import { QuestionnaireEvaluationModal } from '../../questionnaire-evaluation/QuestionnaireEvaluationModal';

export const RepeatedQuestionnaireWrapper = observer(() => {
  const myInfoStore = useUserMeStore();
  const cohortType = myInfoStore.myInfo?.Participant?.cohortType;
  const isAllowedToAccess =
    cohortType === CohortType.ACCESS ||
    cohortType === CohortType.CONVENIENT_ACCESS;

  if (!isAllowedToAccess) return null;

  return (
    <>
      <QuestionnaireEvaluationModal />
      <RepeatedQuestionnaireDialog />
    </>
  );
});
